const fillInObject = (obj, name, value, without_parsing = false) => {
    if (!without_parsing ) {
        obj = JSON.parse(JSON.stringify(obj))
    }
    obj[name] = value;
    return obj;
}

export default fillInObject;